function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleCloseAccountRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 18a6 6 0 100 12 6 6 0 000-12zm0 10a3.996 3.996 0 01-3.858-3h7.716A3.996 3.996 0 0124 28zm-3.858-5a3.981 3.981 0 017.716 0h-7.716z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.008 28.016c.02-1.552.079-6.274 1.406-7.602a21.431 21.431 0 014.413-3.054 2.99 2.99 0 00.716-4.663C9.556 11.646 9 10.91 9 8a3.757 3.757 0 013.998-4A3.758 3.758 0 0117 8c0 2.91-.557 3.646-1.543 4.697a2.988 2.988 0 00.717 4.663 34.91 34.91 0 011.986 1.19 8.031 8.031 0 011.61-1.328 35.587 35.587 0 00-2.624-1.61.99.99 0 01-.23-1.548C18.306 12.584 19 11.334 19 8a5.763 5.763 0 00-6.002-6A5.764 5.764 0 007 8c0 3.333.695 4.583 2.083 6.065a.99.99 0 01-.23 1.547A24.279 24.279 0 004 19c-1.675 1.675-1.947 5.456-1.991 8.991A1.985 1.985 0 003.996 30h14.73a8.048 8.048 0 01-1.64-1.996l-13.078.012z",
    fill: props.color
  }));
}

export default SvgIconPeopleCloseAccountRexOutline;